"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleSignIn = void 0;
const auth_1 = require("firebase/auth");
const Register_1 = __importDefault(require("../api/Register"));
const Authentication_1 = __importDefault(require("./Authentication"));
class AppleSignIn {
    static SignIn() {
        return new Promise((resolve, reject) => {
            var provider = new auth_1.OAuthProvider('apple.com');
            provider.addScope('email');
            provider.addScope('name');
            const auth = (0, auth_1.getAuth)();
            return (0, auth_1.signInWithPopup)(auth, provider).then(result => {
                const credential = auth_1.OAuthProvider.credentialFromResult(result);
                Authentication_1.default.SignInWithApple(credential);
            }).catch(e => {
                if (e.code === 'auth/account-exists-with-different-credential') {
                    var pendingCred = auth_1.OAuthProvider.credentialFromError(e);
                    return Register_1.default.registerUser(pendingCred).then((creds) => {
                        var linkCredential = creds.token;
                        return (0, auth_1.signInWithCustomToken)(auth, linkCredential).then((currentUser) => {
                            return (0, auth_1.linkWithCredential)(currentUser.user, pendingCred).then((linkedResult) => {
                                resolve();
                            }).catch(linkError => {
                                if (linkError.code === 'auth/multi-factor-auth-required') {
                                    // This is a known defect with this call: https://github.com/firebase/firebase-js-sdk/issues/9467
                                    resolve();
                                    return;
                                }
                                reject(linkError);
                            });
                        });
                    }).catch(innerError => reject(innerError));
                }
                else
                    reject(e);
            });
        });
    }
    static GetRedirectResult() {
        return Promise.reject();
    }
    static Revoke(currentProvider, token) {
        return new Promise((resolve, reject) => {
            var provider = new auth_1.OAuthProvider('apple.com');
            provider.addScope('email');
            provider.addScope('name');
            const auth = (0, auth_1.getAuth)();
            return (0, auth_1.signInWithPopup)(auth, provider).then(result => {
                const credential = auth_1.OAuthProvider.credentialFromResult(result);
                const accessToken = credential.accessToken;
                return (0, auth_1.revokeAccessToken)(auth, accessToken).then(() => {
                    Authentication_1.default.RevokeWithApple(accessToken, currentProvider, token);
                    resolve("");
                }).catch(reject);
            }).catch(e => {
                reject(e);
            });
        });
    }
    static HasProvider() {
        var auth = (0, auth_1.getAuth)();
        return auth?.currentUser?.providerData?.filter(userInfo => userInfo?.providerId === 'apple.com')?.length > 0;
    }
}
exports.AppleSignIn = AppleSignIn;
